"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullScreen = void 0;
var _react = _interopRequireWildcard(require("react"));
var _box = require("@oneloop/box");
var _icons = require("@oneloop/icons");
var _text = require("@oneloop/text");
var _SliderSwap = require("./SliderSwap");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var FullScreen = exports.FullScreen = function FullScreen(_ref) {
  var fullscreen = _ref.fullscreen,
    tabContainers = _ref.tabContainers,
    tabSelected = _ref.tabSelected,
    fotos = _ref.fotos,
    index = _ref.index,
    setIndex = _ref.setIndex,
    setTabSelected = _ref.setTabSelected,
    videos = _ref.videos,
    video360 = _ref.video360,
    setFullscreen = _ref.setFullscreen,
    planos = _ref.planos,
    handleImageClickToFullscreen = _ref.handleImageClickToFullscreen,
    URLOpenFullscreen = _ref.URLOpenFullscreen;
  var allFiles = {
    fotos: fotos,
    videos: videos,
    video360: video360,
    planos: planos
  };
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    contTab = _useState2[0],
    setContTab = _useState2[1];
  var windowWidth = window.innerWidth;
  (0, _react.useEffect)(function () {
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [contTab, index]);
  (0, _react.useEffect)(function () {
    var newContTab;
    if (tabSelected === 'videos') {
      newContTab = videos.length;
    } else if (tabSelected === 'fotos') {
      newContTab = fotos.length;
    } else if (tabSelected === 'planos') {
      newContTab = planos.length;
    } else if (tabSelected === 'video360') {
      newContTab = video360.length;
    }
    setContTab(newContTab);
  }, [tabSelected]);
  var changeTabContainer = function changeTabContainer(tab) {
    setIndex(0);
    setTabSelected(tab);
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'ArrowRight') {
      if (index + 1 === contTab) return;
      setIndex(function (prevIndex) {
        return prevIndex + 1;
      });
    }
    if (event.key === 'ArrowLeft') {
      if (index === 0) return;
      setIndex(function (prevIndex) {
        return prevIndex - 1;
      });
    }
    if (event.key === 'Escape') {
      closeFullscreen();
    }
  };
  var closeFullscreen = function closeFullscreen() {
    handleImageClickToFullscreen(URLOpenFullscreen);
    setFullscreen(false);
  };
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "fullscreen ".concat(fullscreen ? 'openFullscreen' : '')
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "fsCloseIconMobile"
  }, /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    onClick: closeFullscreen,
    className: "closeIcon",
    icon: "icon-cerrar"
  })), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "fsOverlay",
    onClick: closeFullscreen
  }), tabContainers.length > 1 && /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "fsTabHeader"
  }, tabContainers.map(function (tab, i) {
    return /*#__PURE__*/_react["default"].createElement(_text.Text, {
      key: i,
      onClick: function onClick() {
        return changeTabContainer(tab.value);
      },
      className: "".concat(tabSelected === tab.value && 'tabSelected'),
      variant: "bodyBold.fontSize14"
    }, tab.label);
  })), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "fsContainerTabs",
    __css: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "fsTabCont"
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "fsTabContImage"
  }, /*#__PURE__*/_react["default"].createElement(_SliderSwap.SliderSwap, {
    setIndex: setIndex,
    fullScreen: fullscreen,
    fileType: tabSelected,
    files: allFiles[tabSelected],
    index: index,
    windowWidth: windowWidth,
    tabSelected: tabSelected
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    className: "contFotos",
    variant: "bodyBold.fontSize14"
  }, "".concat(index + 1, "/").concat(allFiles[tabSelected].length)))), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "fsCloseIconDesktop"
  }, /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    onClick: closeFullscreen,
    className: "closeIcon",
    icon: "icon-cerrar"
  }))));
};